import { render, staticRenderFns } from "./distributorsForm.vue?vue&type=template&id=56cdd349&scoped=true"
import script from "./distributorsForm.vue?vue&type=script&lang=js"
export * from "./distributorsForm.vue?vue&type=script&lang=js"
import style0 from "./distributorsForm.vue?vue&type=style&index=0&id=56cdd349&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cdd349",
  null
  
)

export default component.exports